module.exports = __webpack_public_path__ + "static/media/tools.a6f4b2e7.svg";